import React from 'react';
import { Container, SectionTitle, StepsContainer, Step, StepNumber, StepIcon, StepTitle, StepDescription } from './styled';

const passos = [
  {
    numero: '1',
    icone: '👤',
    titulo: 'Escolha um sábio',
    descricao: 'Salomão, Davi, Ester ou Daniel — cada um tem sua personalidade, história e jeito único de conversar.',
  },
  {
    numero: '2',
    icone: '💬',
    titulo: 'Comece a conversar',
    descricao: 'Pergunte sobre fé, vida, histórias e curiosidades — e descubra o que cada personagem responde, sempre com base na Bíblia.',
  },
  {
    numero: '3',
    icone: '🌱',
    titulo: 'Aprofunde sua jornada',
    descricao: 'Quanto mais você conversa, mais rica fica a experiência. Explore idiomas, histórias e perspectivas únicas.',
  },
];

const ComoFunciona = () => {
  return (
    <Container>
      <SectionTitle>Como funciona?</SectionTitle>
      <StepsContainer>
        {passos.map((passo) => (
          <Step key={passo.numero}>
            <StepNumber>{passo.numero}</StepNumber>
            <StepIcon>{passo.icone}</StepIcon>
            <StepTitle>{passo.titulo}</StepTitle>
            <StepDescription>{passo.descricao}</StepDescription>
          </Step>
        ))}
      </StepsContainer>
    </Container>
  );
};

export default ComoFunciona;
